module.exports = __webpack_public_path__ + "img/ricerca.97eee42c.png";